export enum Constants {
    SIDEBAR_SHOW = 'SIDEBAR_SHOW',
    SIDEBAR_HIDE = 'SIDEBAR_HIDE',
}
